import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantComponent } from './tenant/tenant.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    TenantComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
  ]
})
export class TenantModule { }
